<div class="overview">
  <div class="overview__header">
    <h1>Admin Overview</h1>
    <p>A snapshot of activity across Amaalmomineen.</p>
  </div>

  <div class="overview__stats">
    @for (stat of stats; track stat.label) {
      <div class="stat-card">
        <span class="stat-card__icon" aria-hidden="true">{{ stat.icon }}</span>
        <div class="stat-card__body">
          <span class="stat-card__label">{{ stat.label }}</span>
          <strong class="stat-card__value">{{ stat.value }}</strong>
          <span class="stat-card__change" [class.stat-card__change--negative]="!stat.positive">{{ stat.change }}</span>
        </div>
      </div>
    }
  </div>

  <app-card title="Recent Activity" class="activity-card">
    <ul class="activity-card__list">
      @for (item of recentActivity; track item.time) {
        <li class="activity-card__item">
          <span class="activity-card__dot" aria-hidden="true"></span>
          <span class="activity-card__text"><strong>{{ item.actor }}</strong> {{ item.action }}</span>
          <span class="activity-card__time">{{ item.time }}</span>
        </li>
      }
    </ul>
  </app-card>
</div>
